<template>
    <div class="notificators-form">
        <component :is="currentNotificatorForm" :properties="properties"></component>
        here somewhere

        <button v-on:click.prevent="saveCheck()">Save check</button>
    </div>
</template>

<script>
import NotSelected from "../components/notificators/NotSelected.vue"
import EmailForm from "../components/notificators/EmailForm.vue"
import SMSForm from "../components/notificators/SMSForm.vue"
import API from "../api"

export default {
    props: ["properties"],
    name: 'notificators-form',
    data() {
        return  {
            forms: {
                'email': EmailForm,
                'sms': SMSForm
            },
            currentNotificatorForm: false
        }
    },
    watch: {
        "properties.type"() {
            this.currentNotificatorForm = this.forms[this.properties.type]
        },
    },
    methods: {
        saveCheck() {
            const notificator = {
                type: this.properties.type,
                properties: this.properties
            }

            API.notificators.Save(notificator).then(response => {
                console.log(response);
            })
        }
    }
}
</script>

<style lang="scss">
.notificators-form {
    form {
        border: none;
        margin: 0;
        padding: 0;
        box-shadow: none;

        input {
            width: 100%;
        }

        textarea {
            width: 100%;
            min-height: 200px;
        }

        .helper {
            font-size: 13px;
            padding: 0px 6px 13px;
            margin: 0;
            color: #676767;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/NotificatorsForm.vue